import { render, staticRenderFns } from "./Naturalanti-oxidant.vue?vue&type=template&id=342bb4f2&scoped=true&"
import script from "./Naturalanti-oxidant.vue?vue&type=script&lang=js&"
export * from "./Naturalanti-oxidant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342bb4f2",
  null
  
)

export default component.exports